﻿import $ from "jquery";
import require from "require";
import LogoWidget from "./LogoWidget";

export default class LogoWidgetCarousel extends LogoWidget {

	constructor() {
		require("slick");
		super(...arguments);
	}

	init() {
		super.init();

		const _ = this;

		_.vertical = _.model.settings.layout === "vertical";
		_.setLayoutAttr();

		const $products = $.map(_.model.products, (data, index) => _.buildProduct(index));
		const $slick = $("<div>").append($products).appendTo(_.$container);

		$slick
			.one("init", (e, slick) => {
				_.slick = slick;
				setTimeout(() => _.resize(), 0);
			})
			.on("beforeChange", (e, slick, curr, next) => _.logNavigate(curr, next))
			.ccsSlick({
				infinite: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				vertical: _.vertical,
				verticalSwiping: _.vertical,
				appendArrows: _.$container,
				draggable: false,
				swipe: ccs_util.isMobile()
			});
	}

	resize() {
		super.resize(() => {
			this.updateOrientation();
			this.setSlidesCount();
		});
	}

	updateOrientation() {
		const _ = this, slick = _.slick;

		if (!slick || _.model.settings.layout !== "auto") {
			return;
		}

		const vertical = _.$root.height() * 1.1 > _.$root.width();

		if (_.vertical !== vertical) {

			_.vertical = vertical;
			_.setLayoutAttr();

			slick.setOption("vertical", vertical);
			slick.setOption("verticalSwiping", vertical);
			slick.refresh();
		}
	}

	setLayoutAttr() {
		this.$wrap.attr("data-layout", this.vertical ? "vertical" : "horizontal");
	}

	setSlidesCount() {
		const _ = this, slick = _.slick;

		if (!slick) {
			return;
		}

		let maxSize, wrapSize;

		if (_.vertical) {
			maxSize = _.setSlideMaxHeight(slick.$slides);
			wrapSize = _.getAvailableHeight();

		} else {
			slick.$slides.height("");

			maxSize = _.$outer.height() > 120 ? 200 : 240;
			wrapSize = slick.$list.width();
		}

		const targetCount = _.calcSlideCount(wrapSize, maxSize, slick.slideCount);

		if (slick.options.slidesToShow !== targetCount) {
			_.$container.toggleClass("ccs-noarrows", slick.slideCount === targetCount);

			slick.slickSetOption("slidesToShow", targetCount);
			slick.slickSetOption("slidesToScroll", targetCount);

			_.dontLogNavEvent = true;
			slick.goTo(slick.currentSlide);
			_.dontLogNavEvent = false;
		}

		slick.setPosition();
	}

	setSlideMaxHeight($slides) {
		$slides.height("");

		const maxHeight = Math.max.apply(null, $slides.map((i, slide) => $(slide).outerHeight()));
		$slides.outerHeight(maxHeight);

		return maxHeight;
	}

	getAvailableHeight() {
		const _ = this;

		const outerHeight = _.$outer.height();
		const innerPadding = _.$inner.outerHeight(true) - _.$inner.height();
		const containerPadding = _.$container.outerHeight(true) - _.$container.height();
		const headerHeight = _.$header.outerHeight(true);

		return outerHeight - innerPadding - containerPadding - headerHeight;
	}

	calcSlideCount(wrapSize, slideSize, totalCount) {
		return Math.min(Math.max(Math.floor(wrapSize / slideSize), 1), totalCount);
	}

	logNavigate(prev, next) {
		const _ = this, slick = _.slick;

		if (_.dontLogNavEvent || prev === next) {
			return;
		}

		const dir = prev > next ? "back" : "forward";

		const total = slick.slideCount;
		const qty = slick.options.slidesToShow;

		let start;

		if (next + qty > total) {
			start = total - qty + 1;
		} else {
			start = next + 1;
		}

		const params = {
			dir: dir,
			vertical: _.vertical,
			start: start,
			qty: qty,
			total: total
		}

		super.logNavigate(params);
	}
}
